// API Configuration
const DEFAULT_API_URL = 'http://localhost:3001/api';
const LOOPBACK_HOSTS = new Set(['localhost', '127.0.0.1']);

export const resolveApiUrl = (
  rawUrl = process.env.REACT_APP_API_URL || DEFAULT_API_URL,
  locationLike = typeof window !== 'undefined' ? window.location : null
) => {
  if (typeof rawUrl !== 'string' || !rawUrl.trim()) {
    return DEFAULT_API_URL;
  }

  const trimmedUrl = rawUrl.trim();

  try {
    const parsed = new URL(trimmedUrl);
    const currentHostname = locationLike?.hostname;

    if (
      currentHostname
      && LOOPBACK_HOSTS.has(currentHostname)
      && LOOPBACK_HOSTS.has(parsed.hostname)
      && parsed.hostname !== currentHostname
    ) {
      parsed.hostname = currentHostname;
    }

    return parsed.toString().replace(/\/$/, '');
  } catch (_error) {
    return trimmedUrl.replace(/\/$/, '');
  }
};

export const API_URL = resolveApiUrl();

// Default Values
export const DEFAULT_BUDGET = 5300;
export const DEFAULT_NUM_ADULTS = 2;
export const DEFAULT_NUM_CHILDREN = 0;
export const DEFAULT_CURRENCY = 'USD';

// UI Constants
export const MAX_NOTIFICATIONS = 20;
export const REDIRECT_DELAY_MS = 2000;
export const EMAIL_VERIFY_REDIRECT_DELAY_MS = 2000;
export const ONBOARDING_REDIRECT_DELAY_MS = 2000;

// Validation
export const MIN_PASSWORD_LENGTH = 8;
export const TWO_FA_CODE_LENGTH = 6;
export const TRUST_DEVICE_DAYS = 30;

// Budget Alerts
export const BUDGET_WARNING_THRESHOLD = 90; // 90% of budget
export const BUDGET_EXCEEDED_THRESHOLD = 100; // 100% of budget

// Currency Map
export const CURRENCY_MAP = {
  'US': 'USD',
  'CA': 'CAD',
  'GB': 'GBP',
  'DE': 'EUR',
  'FR': 'EUR',
  'IT': 'EUR',
  'ES': 'EUR',
  'NL': 'EUR',
  'PT': 'EUR',
  'BE': 'EUR',
  'AT': 'EUR',
  'AU': 'AUD',
  'JP': 'JPY',
  'CN': 'CNY',
  'IN': 'INR',
  'MX': 'MXN',
  'BR': 'BRL'
};

// Onboarding Steps
export const ONBOARDING_STEPS = [
  'Connect Bank',
  'Invite Others'
];

// Supported Currencies
export const SUPPORTED_CURRENCIES = [
  { value: 'USD', label: 'USD ($)' },
  { value: 'CAD', label: 'CAD ($)' },
  { value: 'EUR', label: 'EUR (€)' },
  { value: 'GBP', label: 'GBP (£)' },
  { value: 'AUD', label: 'AUD ($)' },
  { value: 'JPY', label: 'JPY (¥)' }
];
